<header accent="note" title="Add Entity" icon="rocket">
  <utils>
    <novo-action icon="times" tooltip="Close" ></novo-action>
  </utils>
</header>


<section cdkscrollable class="compose-message-form-body-container scrollable-content ng-star-inserted">
  <main>
    <novo-form *ngIf="textForm" [form]="textForm">
      <div class="novo-form-row">
        <novo-control [form]="textForm" [control]="textControl"></novo-control>
      </div>
      <div class="novo-form-row">
        <novo-control [form]="textForm" [control]="jobOrderPickerControl"></novo-control>
      </div>
      <div class="novo-form-row">
        <novo-control [form]="textForm" [control]="candidatePickerControl"></novo-control>
      </div>
      <div class="novo-form-row">
        <novo-control [form]="textForm" [control]="ownerPickerControl"></novo-control>
      </div>
      <div class="novo-form-row">
        <novo-control [form]="textForm" [control]="commentsControl"></novo-control>
      </div>
    </novo-form>
  </main>
  <footer class="form-footer"><button theme="standard" >Cancel</button><button style="margin-left: 15px;" theme="primary" icon="send">Send</button></footer>
</section>